import { PayloadAction } from '@reduxjs/toolkit';
import applySelectionToFilters from 'utils/applySelectionToFilters';
import { SearchResponse, SearchState } from '../types';

const setCurrentResultsReducer = (state: SearchState, action: PayloadAction<SearchResponse>) => {
  state.filters = applySelectionToFilters(action.payload.filters, state.settings.filters);
  state.parsedQuery = action.payload.parsedQuery;
  state.previewMasks = action.payload.previewMasks;
  const insertBefore = action.payload.offset < state.offset;
  if (action.payload) {
    if (state.results && state.results.products) {
      if (insertBefore) {
        state.results.products = [...action.payload.products, ...state.results.products];
      } else {
        state.results.products.push(...action.payload.products);
      }
    } else {
      state.results = action.payload;
    }
    state.offset = Math.min(state.offset, action.payload.offset);
    state.totalFetched += action.payload.products?.length || 0;
    state.totalAvailable = action.payload.hits;
  } else {
    state.results.products = [];
    state.parsedQuery = '';
    state.offset = 0;
    state.totalFetched = 0;
    state.totalAvailable = 0;
  }
};

export default setCurrentResultsReducer;
